import routeShellConfig from "../../config/route-shell.json";
import { languageForPrefix } from "../i18n/countries.js";

const marketingExactRoutes = new Set(routeShellConfig.marketingExactRoutes || []);
const marketingPrefixes = routeShellConfig.marketingPrefixes || [];

export function normalizeRouteShellPath(pathname = "/") {
  return String(pathname || "/").replace(/\/+$/, "") || "/";
}

// Translated marketing pages live under their language (/de/pricing/): matched without
// it, for the languages the site shows (index.html's inline script does the same).
export function stripRouteShellLanguagePrefix(pathname = "/") {
  const match = /^\/([a-z]{2})(?=\/|$)/.exec(pathname);
  if (!match || !languageForPrefix(match[1])) return pathname;
  return pathname.slice(match[0].length) || "/";
}

export function isMarketingRoute(pathname = "/") {
  const normalizedPathname = stripRouteShellLanguagePrefix(normalizeRouteShellPath(pathname));
  if (marketingExactRoutes.has(normalizedPathname)) return true;
  return marketingPrefixes.some(
    (prefix) => normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`)
  );
}

export function getRouteShell(pathname = "/") {
  return isMarketingRoute(pathname) ? "marketing" : "app";
}

export { marketingExactRoutes, marketingPrefixes };
